import React, { useEffect, useState } from 'react'
import { useRolePreview, ROLES } from './RolePreviewContext'
import { hasSessionHint } from '../utils/session'
import './RolePreviewSelector.css'

const PREVIEW_OPTIONS = [
  { value: null, label: 'Actual (Admin)' },
  ...ROLES.filter((role) => role.value !== 'admin'),
]

/**
 * Inline role preview picker for Account Settings (admin + debug mode).
 */
const RolePreviewSelector = () => {
  const { previewRole, setPreviewRole } = useRolePreview()
  const [isAdmin, setIsAdmin] = useState(false)

  useEffect(() => {
    try {
      if (!hasSessionHint()) {
        setIsAdmin(false)
        return
      }
      const userStr = localStorage.getItem('user')
      if (!userStr) {
        setIsAdmin(false)
        return
      }
      const user = JSON.parse(userStr)
      const role = user.role != null ? String(user.role).trim().toLowerCase() : ''
      setIsAdmin(role === 'admin')
    } catch {
      setIsAdmin(false)
    }
  }, [])

  if (!isAdmin) return null

  return (
    <div className="role-preview-selector" role="group" aria-label="View as role">
      {PREVIEW_OPTIONS.map((option) => {
        const isActive = option.value ? previewRole === option.value : !previewRole
        return (
          <button
            key={option.value ?? 'admin'}
            type="button"
            className={`role-preview-selector-option ${isActive ? 'active' : ''}`}
            aria-pressed={isActive}
            onClick={() => setPreviewRole(option.value)}
          >
            {option.label}
          </button>
        )
      })}
    </div>
  )
}

export default RolePreviewSelector
